import { useCallback, useMemo, useRef, useState } from "react";
import Defaults from "../../helper/defaults";

const snapshot = (filters = {}) => ({
  termsInclude: [...(filters.termsInclude ?? filters.TermsInclude ?? [])],
  termsExclude: [...(filters.termsExclude ?? filters.TermsExclude ?? [])],
  industryInclude: [...(filters.industryInclude ?? filters.IndustryInclude ?? [])],
  industryExclude: [...(filters.industryExclude ?? filters.IndustryExclude ?? [])],
  locations: [...(filters.locations ?? filters.Location ?? [])],
  revenueLowerBound: filters.revenueLowerBound ?? filters.RevenueLowerBound ?? Defaults.search.revenueLowerBound,
  revenueUpperBound: filters.revenueUpperBound ?? filters.RevenueUpperBound ?? Defaults.search.revenueUpperBound,
  employeesLowerBound: filters.employeesLowerBound ?? filters.EmployeesLowerBound ?? Defaults.search.employeesLowerBound,
  employeesUpperBound: filters.employeesUpperBound ?? filters.EmployeesUpperBound ?? Defaults.search.employeesUpperBound,
});

const keyOf = (filters) => JSON.stringify(snapshot(filters));

export default function useDeferredFilterCommit(draft, restoreDraft) {
  const [committed, setCommitted] = useState(() => snapshot(draft));
  const draftRef = useRef(draft);
  draftRef.current = draft;
  const draftKey = keyOf(draft);
  const committedKey = keyOf(committed);
  const hasUncommittedFilters = draftKey !== committedKey;

  const commitFilters = useCallback(() => {
    setCommitted((current) => keyOf(current) === keyOf(draftRef.current)
      ? current
      : snapshot(draftRef.current));
  }, []);
  const discardFilters = useCallback(() => {
    if (hasUncommittedFilters) restoreDraft(committed);
  }, [committed, hasUncommittedFilters, restoreDraft]);
  const hydrateFilters = useCallback((filters) => setCommitted(snapshot(filters)), []);

  return useMemo(() => ({
    committedFilters: committed,
    commitFilters,
    discardFilters,
    hydrateFilters,
    hasUncommittedFilters,
  }), [commitFilters, committed, discardFilters, hasUncommittedFilters, hydrateFilters]);
}
